export default {
  apiKey: 'AIzaSyBEYQnoRmgmb9SHW4OyjXSpsIAldFSxYHk',
  authDomain: 'engage4.firebaseapp.com',
  databaseURL: 'https://engage4.firebaseio.com',
  projectId: 'engage4',
  storageBucket: 'engage4.appspot.com',
  messagingSenderId: '259587820456',
  appId: '1:259587820456:web:f77c414b42b0c44da46b9d',
  measurementId: 'G-KE31S8T89Z',
};
